import {Component, Input, OnInit} from "@angular/core";
import {FormControl} from "@angular/forms";
import {DbServerErrors} from "../../../../../shared/interceptors/db-server-errors";
import {HostingService} from "../../hosting.service";
import {Website} from "../../../website";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {filter, first} from "rxjs/operators";
import {DbModalService} from "../../../../../modules/modal/modal";

@Component({
    selector: 'db-add-domain-list-dialog',
    templateUrl: './add-domain-list-dialog.component.html',
    styleUrls: ['./add-domain-list-dialog.component.scss'],
    standalone: false
})
export class AddDomainListDialogComponent implements OnInit {

  @Input() website: Website;
  public websiteUrl: string;
  public loading: boolean = false;
  public responseReceived: boolean;
  public formSubmitted: boolean;
  public domainName: FormControl;
  public serverErrors: DbServerErrors;
  public domains: any[];

  constructor(
    private _hostingService: HostingService,
    public activeModal: DbActiveModal,
    private _modalService: DbModalService
  ) {
  }

  ngOnInit() {
    this.websiteUrl = this.website && this.website.site_url.replace(/^https?:\/\//i, '');
    this.formSubmitted = false;
    this.domainName = new FormControl("");
  }

  public linkDomain(): void {
    const websiteID = this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id;
    this.loading = true;
    this._hostingService.createDomain(websiteID, {domain_name: this.domainName.value})
      .pipe(
        filter((_response: DbResponse): boolean => !!_response),
        first()
      ).subscribe((response: DbResponse): void => {
      if (response.success) {
        this.responseReceived = true;
        this.activeModal.close({success: true});
      } else {
        this.serverErrors = response.serverErrors;
        NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
      }
      this.loading = false;
    });
  }

}
